<template>
  <div class="h-screen flex w-full bg-img" id="page-login">
    <div class="vx-row m-auto">
      <div class="vx-col w-full full-page">
        <h1 align="center" class="my-4">{{ $t('labels.gmsIq') }}</h1>
        <div class="vx-row justify-center flex">
          <div class="vx-col w-full">
            <vx-card class="mx-auto resetpass-card">
              <div slot="no-body" class="page-bg-color px-6">
                <div class="vx-row w-full m-0">
                  <div class="vx-col d-theme-dark-bg w-full p-0">
                    <div class="pt-8 pb-8">
                      <div class="vx-card__title my-5">
                        <h2 align="center">{{$t('labels.reset_password')}}</h2>
                        <p class="py-4" align="center">{{ $t('strings.reset_pass_account') }}</p>
                      </div>
                      <form autocomplete="off" @submit.prevent="checkValidation()">
                        <div>
                          <div class="my-5 mb-8">
                            <vs-input
                              v-validate="'required'"
                              type="password"
                              class="w-full"
                              name="password_recovery"
                              icon-pack="feather"
                              icon="icon-unlock"
                              icon-no-border
                              :label="$t('labels.password_recovery')"
                              v-model="recovery_password"
                            />
                            <span
                              class="text-danger text-sm"
                            >{{ errors.first('password_recovery') }}</span>

                            <vs-input
                              ref="password"
                              v-validate="'required|min:6'"
                              type="password"
                              class="w-full pt-4"
                              name="new_password"
                              icon-pack="feather"
                              icon="icon-lock"
                              icon-no-border
                              :label="$t('labels.new_password')"
                              v-model="new_password"
                            />
                            <span class="text-danger text-sm">{{ errors.first('new_password') }}</span>

                            <vs-input
                              type="password"
                              class="w-full pt-4"
                              v-validate="'required|confirmed:password'"
                              name="password_confirmation"
                              icon-pack="feather"
                              icon="icon-lock"
                              icon-no-border
                              :label="$t('labels.confirm_password')"
                              v-model="confirm_password"
                            />
                            <span
                              class="text-danger text-sm"
                            >{{ errors.first('password_confirmation') }}</span>
                          </div>
                          <div class="my-5" align="center">
                            <vs-button
                              :disabled="button_loading"
                              id="reset-password"
                              button="submit"
                              class="vs-component vs-button md:w-auto mb-8 md:mt-0 md:mb-0 vs-button-filled login-btn"
                            >{{$t('labels.reset_pass_button')}}</vs-button>
                          </div>
                          <div class="mb-3 mt-5 forgot-pass" align="center">
                            <router-link
                              :to="{name:'ForgotPassword'}"
                            >{{$t('labels.backto_forgotpassword')}}</router-link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "getResetPasswordField",
  mutationType: "updateResetPasswordField"
});

export default {
  computed: {
    ...mapFields(["recovery_password", "new_password", "confirm_password"])
  },
  mounted() {
    this.setValidationMessage();
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updatePassword();
        }
      });
    },
    async updatePassword() {
      let input = {
        recovery_password: this.recovery_password,
        password: this.new_password,
        password_confirmation: this.confirm_password
      };
      let response = await this.getHTTPPostResponse(
        "/reset-password",
        input,
        "#reset-password",
        true
      );
      if (response) {
        this.$router.push({ name: "login" });
      }
    },
    destroyed() {
      this.$store.commit("clearPasswordField", null, { module: "login" });
    }
  }
};
</script>
<style>
h2 ~ p {
  color: #000000;
  font-size: 17px;
}
.reset-password .vs-divider-border {
  border: 0 !important;
}
button.login-btn.vs-button-primary.vs-button-filled {
  background: rgba(var(--vs-primary), 1) !important;
}
button.login-btn.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}
</style>
